"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensReasonId = exports.LensReasonId_ReasonId = void 0;
/* eslint-disable */
const minimal_1 = __importDefault(require("protobufjs/minimal"));
/** Enum of accepted feedback reasons. */
var LensReasonId_ReasonId;
(function (LensReasonId_ReasonId) {
    /** UNSET - Unset. */
    LensReasonId_ReasonId[LensReasonId_ReasonId["UNSET"] = 0] = "UNSET";
    /** THREATENING_1P - Reported lens contains threatening content of the reporter */
    LensReasonId_ReasonId[LensReasonId_ReasonId["THREATENING_1P"] = 1] = "THREATENING_1P";
    /** THREATENING_3P - Reported lens contains threatening content of another user */
    LensReasonId_ReasonId[LensReasonId_ReasonId["THREATENING_3P"] = 2] = "THREATENING_3P";
    /** THREATENING_RELIGION_CULTURE - Reported lens contains threatening content of religions or cultures */
    LensReasonId_ReasonId[LensReasonId_ReasonId["THREATENING_RELIGION_CULTURE"] = 3] = "THREATENING_RELIGION_CULTURE";
    /** INAPPROPRIATE_VIOLENT - Reported lens contains overly violent content */
    LensReasonId_ReasonId[LensReasonId_ReasonId["INAPPROPRIATE_VIOLENT"] = 4] = "INAPPROPRIATE_VIOLENT";
    /** INAPPROPRIATE_SEXUAL - Reported lens contains overly sexual content */
    LensReasonId_ReasonId[LensReasonId_ReasonId["INAPPROPRIATE_SEXUAL"] = 5] = "INAPPROPRIATE_SEXUAL";
    /** INAPPROPRIATE_ALCOHOL_DRUGS - Reported lens promotes alcohol or drugs */
    LensReasonId_ReasonId[LensReasonId_ReasonId["INAPPROPRIATE_ALCOHOL_DRUGS"] = 6] = "INAPPROPRIATE_ALCOHOL_DRUGS";
    /** INAPPROPRIATE_SKIN_TONE - Reported lens alters reporter's skin tone */
    LensReasonId_ReasonId[LensReasonId_ReasonId["INAPPROPRIATE_SKIN_TONE"] = 7] = "INAPPROPRIATE_SKIN_TONE";
    /** AI_ETHNICITY_SKIN_TONE - Reported lens ai image alters reporter's skin tone or ethnicity */
    LensReasonId_ReasonId[LensReasonId_ReasonId["AI_ETHNICITY_SKIN_TONE"] = 8] = "AI_ETHNICITY_SKIN_TONE";
    /** AI_SEXUAL_NUDITY - Reported lens ai image contains sexual suggestive content or nudity */
    LensReasonId_ReasonId[LensReasonId_ReasonId["AI_SEXUAL_NUDITY"] = 9] = "AI_SEXUAL_NUDITY";
    /** AI_MISMATCHED_GENDER - Reported lens ai image mismatches reporter's gender */
    LensReasonId_ReasonId[LensReasonId_ReasonId["AI_MISMATCHED_GENDER"] = 10] = "AI_MISMATCHED_GENDER";
    /** AI_GENERATED_RESULT_OFFENSIVE - Reported lens ai image offensive */
    LensReasonId_ReasonId[LensReasonId_ReasonId["AI_GENERATED_RESULT_OFFENSIVE"] = 11] = "AI_GENERATED_RESULT_OFFENSIVE";
    /** AI_FALSE_POLITICAL_INFORMATION - Reported lens ai image contains false political information */
    LensReasonId_ReasonId[LensReasonId_ReasonId["AI_FALSE_POLITICAL_INFORMATION"] = 12] = "AI_FALSE_POLITICAL_INFORMATION";
    /** RE_REPORT_DIDNT_WORK_CATEGORY - Lens didn't work category already reported */
    LensReasonId_ReasonId[LensReasonId_ReasonId["RE_REPORT_DIDNT_WORK_CATEGORY"] = 13] = "RE_REPORT_DIDNT_WORK_CATEGORY";
    /** RE_REPORT_INAPPROPRIATE_CATEGORY - Lens inappropriate category already reported */
    LensReasonId_ReasonId[LensReasonId_ReasonId["RE_REPORT_INAPPROPRIATE_CATEGORY"] = 14] = "RE_REPORT_INAPPROPRIATE_CATEGORY";
    /** RE_REPORT_THREATENING_CATEGORY - Lens threatening/harrassment category already reported */
    LensReasonId_ReasonId[LensReasonId_ReasonId["RE_REPORT_THREATENING_CATEGORY"] = 15] = "RE_REPORT_THREATENING_CATEGORY";
    /** UNFLATTERING - Lens looks unflattering */
    LensReasonId_ReasonId[LensReasonId_ReasonId["UNFLATTERING"] = 16] = "UNFLATTERING";
    /** BORING - Lens looks boring */
    LensReasonId_ReasonId[LensReasonId_ReasonId["BORING"] = 17] = "BORING";
    /** NOT_CREATIVE - Lens is not creative */
    LensReasonId_ReasonId[LensReasonId_ReasonId["NOT_CREATIVE"] = 18] = "NOT_CREATIVE";
    /** DONT_LIKE_AI_GENERATED - AI generated Lens is not liked */
    LensReasonId_ReasonId[LensReasonId_ReasonId["DONT_LIKE_AI_GENERATED"] = 19] = "DONT_LIKE_AI_GENERATED";
    /** CRASHES_APP - Lens causes an app crash */
    LensReasonId_ReasonId[LensReasonId_ReasonId["CRASHES_APP"] = 20] = "CRASHES_APP";
    /** FREEZES_APP - Lens causes the app to freeze */
    LensReasonId_ReasonId[LensReasonId_ReasonId["FREEZES_APP"] = 21] = "FREEZES_APP";
    /** RESULTS_ARE_NOT_EXPECTED - Lens results are not what is expected by the user */
    LensReasonId_ReasonId[LensReasonId_ReasonId["RESULTS_ARE_NOT_EXPECTED"] = 22] = "RESULTS_ARE_NOT_EXPECTED";
    LensReasonId_ReasonId[LensReasonId_ReasonId["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LensReasonId_ReasonId = exports.LensReasonId_ReasonId || (exports.LensReasonId_ReasonId = {}));
function createBaseLensReasonId() {
    return { reasonId: 0 };
}
exports.LensReasonId = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.reasonId !== 0) {
            writer.uint32(8).int32(message.reasonId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensReasonId();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.reasonId = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensReasonId();
        message.reasonId = object.reasonId ?? 0;
        return message;
    },
};
//# sourceMappingURL=lens_reason_id.js.map